<template>
  <el-checkbox
    class="jr-checkbox"
    :modelValue="modelValue"
    @update:modelValue="update($event)"
    :disabled="disabled"
    :size="size"
    v-if="isEdit"
  >
    <slot></slot>
  </el-checkbox>
  <jr-input-view v-else :size="size"> <slot v-if="modelValue"></slot></jr-input-view>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import JrInputView from '@/components/jr-parts/JrInputView.vue'

export default defineComponent({
  name: 'JrCheckbox',
  emits: ['update:modelValue'],
  components: { JrInputView },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props, context) {
    return {
      update: (event: boolean) => {
        context.emit('update:modelValue', event)
      },
    }
  },
})
</script>
<style lang="scss" scoped>
.jr-checkbox ::v-deep(.el-checkbox__input) {
  z-index: 0;
}
</style>
